export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-fr-8a93691210d11296a1e2c0fe8b82233a.webp";